import React from "react";

const PaymentListRow = ({
  data,
  onView,
  onEdit,
  onDelete,
  isLoading,
  handleStatusChange,
  isLoadingUserStatus,
}) => {
  return (
    <>
      {data?.map((item, index) => {
        return (
          <tr
            className="cursor-pointer"
            onClick={() => onView(item)}
            key={index}
          >
            <td className="align-middle px-4">{item.transactionId || "N/A"}</td>
            <td className="align-middle px-4 ">
              <span className="text-secondary text-sm font-weight-bold text-center">
                {item.userEmail || "N/A"}
              </span>
            </td>
            <td className="align-middle px-4 ">{item.journeyName || "N/A"}</td>
            <td className="align-middle px-4 ">{item.amount || "0.00"}</td>
            <td className="align-middle px-4 ">
              <span
                style={{ width: "100px" }}
                class="badge badge-sm bg-gradient-success cursor-pointer"
              >
                Paid
              </span>
            </td>
            <td className="align-middle px-4">
              {item.createdAt
                ? new Date(item.createdAt).toISOString().split("T")[0]
                : "N/A"}
            </td>
          </tr>
        );
      })}
    </>
  );
};

export default PaymentListRow;
